module.exports = __webpack_public_path__ + "img/20200817_occ_por_x.4c0be112.png";